export default "__VITE_ASSET__BYENwFXj__"